import type { Facing } from '@homework/shared';

/**
 * Where this browser last had you standing, for this page load only.
 *
 * Moving between pages in the app should leave you where you were — the office
 * is still open behind you, and being teleported to your desk mid-meeting ends
 * the call. Signing out or closing the tab is different: you left, and you come
 * back to your desk. A module variable draws exactly that line, because it
 * survives a route change and nothing else.
 *
 * It lives in its own file so signing out can clear it without the auth
 * provider importing the office page, which would pull the whole map renderer
 * into the first thing every visitor downloads.
 */

interface CarriedPosition {
  userId: string;
  x: number;
  y: number;
  facing: Facing;
}

let carried: CarriedPosition | null = null;

/** Keyed by user, so signing in as somebody else does not inherit a position. */
export function carriedPositionFor(userId: string): CarriedPosition | null {
  return carried?.userId === userId ? carried : null;
}

export function rememberPosition(position: CarriedPosition): void {
  carried = position;
}

export function forgetCarriedPosition(): void {
  carried = null;
}
